import { AbstractControl, ValidatorFn } from '@angular/forms';

export const isWelbyClinicalValidator: ValidatorFn = (control: AbstractControl) => {
  const isWelbyClinical = control.get('isWelbyClinical')?.value;
  const lead = control.get('lead')?.value;
  const highestLicensure = control.get('highest_licensure')?.value;

  if (isWelbyClinical && (!lead || !highestLicensure)) {
    return { welbyClinicalDataRequired: true };
  }
  return null;
};
